// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7190c45a","396":"c996c535","455":"7d56aa64","857":"8425d1b5","977":"7cfe0b0d"}[chunkId] + ".chunk.js";
};